/** Shared MONT2 Academy contact & outbound links (used across pages). */

export const SITE_PHONE_E164 = "+919821721889";
export const SITE_PHONE_DISPLAY = "+91 9821721889";
export const SITE_EMAIL = "contact@mont2academy.com";
export const SITE_SECONDARY_PHONE_E164 = "+919971328459";
export const SITE_SECONDARY_PHONE_DISPLAY = "+91 99713 28459";
export function whatsappUrl(body: string) {
  return `https://wa.me/919821721889?text=${encodeURIComponent(body)}`;
}

export const SITE_WHATSAPP_PREFILL =
  "Hi MONT2 Academy, I want course details and upcoming batch information.";

export const SITE_WHATSAPP_URL_DEFAULT = whatsappUrl(SITE_WHATSAPP_PREFILL);

export const GOOGLE_MAPS_DIRECTIONS_URL =
  "https://www.google.com/maps/search/?api=1&query=MONT2+Academy+:+Data+Science,+Data+Analytics+and+Machine+Learning+course+in+Delhi,+South+Delhi";

export const GOOGLE_REVIEWS_SEARCH_URL =
  "https://www.google.com/search?q=MONT2+Academy+:+Data+Science,+Data+Analytics+and+Machine+Learning+course+in+Delhi,+South+Delhi";

export const INSTAGRAM_URL = "https://www.instagram.com/mont2academy?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==";
export const YOUTUBE_URL = "https://www.youtube.com/@MONT2Academy";

export const GST_PRICE_NOTE = "All fees shown exclude GST (as per brochure).";

export const SITE_FAQS = [
  {
    q: "Are these classes suitable for working professionals?",
    a: "Yes. Programs are designed for both working professionals and students.",
  },
  {
    q: "Who trains the students?",
    a: "Training is delivered by professional data scientists with practical industry experience.",
  },
  {
    q: "Can I pay in EMI?",
    a: "Yes. Major courses include a 3-month EMI option. Detailed EMI amounts are listed with each course.",
  },
  {
    q: "How do I get upcoming batch timings?",
    a: "Call us, use WhatsApp, or submit the enquiry form — our team will share the latest schedule.",
  },
  {
    q: "Are classes online, offline, or hybrid?",
    a: "Batch format can vary by program and intake. Message us on WhatsApp or call — we will confirm the current mode (classroom / online / blended) for the course you choose.",
  },
  {
    q: "Will I get study material and assignments?",
    a: "Yes. Programs include structured notes, assignments, and case-style exercises aligned with the MONT2 training plan so you can practice beyond lectures.",
  },
  {
    q: "Do you help with resume, projects, or interview preparation?",
    a: "Counseling focuses on job-ready skills and portfolio-style work. Ask our team what support is bundled with your selected track.",
  },
  {
    q: "Is GST included in the fees shown on the website?",
    a: "Fees are shown as INR amounts excluding GST, consistent with the brochure. Our team can share the exact payable amount for your course and payment option.",
  },
  {
    q: "Can I switch between courses or upgrade later?",
    a: "Many learners start with a shorter track and move to a broader program. Share your goal on WhatsApp — we will suggest the best ladder and any fee adjustment rules.",
  },
  {
    q: "What if I miss a few sessions?",
    a: "Policies depend on the batch and program. Contact us with your course name and dates — we will explain catch-up options, if any, for that intake.",
  },
  {
    q: "How do I verify timings for the Mehrauli centre?",
    a: "Use the Google Maps link in the footer or on the Reviews page for directions. For class timings, WhatsApp or call is fastest.",
  },
  {
    q: "Is there a refund or transfer policy?",
    a: "Enrollment terms can vary by program. Please ask our desk for the policy that applies to the batch you are joining before you pay.",
  },
] as const;

/** Tool stack with brand icons (Devicon CDN). `iconUrl: null` uses a Lucide fallback on the Tools page. */
export const SITE_TOOL_ENTRIES = [
  {
    name: "Python",
    iconUrl:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@2.15.1/icons/python/python-original.svg",
    description: "Versatile language for data analysis and machine learning.",
  },
  {
    name: "Machine Learning",
    iconUrl: "/tools/ML.webp",
    description: "Build predictive models and advanced data algorithms.",
  },
  {
    name: "SQL",
    iconUrl: "/tools/microsoft-sql-server4529.png",
    description: "Query, manage, and extract insights from relational databases.",
  },
  {
    name: "Tableau",
    iconUrl: "https://upload.wikimedia.org/wikipedia/commons/4/4b/Tableau_Logo.png",
    description: "Create interactive visual analytics and business dashboards.",
  },
  {
    name: "Microsoft Power BI",
    iconUrl: "/tools/Power-BI-Logo.png",
    description: "Transform raw data into compelling visual stories.",
  },
  {
    name: "SAS",
    iconUrl: "https://upload.wikimedia.org/wikipedia/commons/1/10/SAS_logo_horiz.svg",
    description: "Advanced statistical analysis and enterprise data management.",
  },
  {
    name: "Advance Excel",
    iconUrl: "/tools/excel.webp",
    description: "Master complex formulas, pivot tables, and data modeling.",
  },
  {
    name: "Alteryx",
    iconUrl: "/tools/alteryx.png",
    description: "Automate data prep, blending, and advanced analytics workflows.",
  },
] as const;
